import { type MouseEvent, useCallback } from 'react'

/**
 * Enables smooth scrolling for hash anchor links.
 *
 * Next.js client-side transitions conflict with CSS `scroll-behavior: smooth`,
 * so we disable it globally and opt-in via this hook where needed.
 */
export function useSmoothAnchorScroll() {
  const handleSmoothScroll = useCallback((event: MouseEvent<HTMLAnchorElement>) => {
    event.preventDefault()

    const href = event.currentTarget.getAttribute('href')
    if (!href?.startsWith('#')) return

    const targetId = href.slice(1)
    const targetElement = document.getElementById(targetId)

    if (targetElement) {
      const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches

      targetElement.scrollIntoView({
        behavior: prefersReducedMotion ? 'auto' : 'smooth',
      })
    }
  }, [])

  return handleSmoothScroll
}
